import { ArticleDto } from "@/dtos/articleDto";

export class ArticleHelper {
	/**
	 * Creates a text to show at the user interface to inform the user
	 * about the weldline features.
	 */
	public static getWeldlineString(article: ArticleDto): string {
		var text = "";
		if (article.weldlines.length === 1) {
			text = "1 Schweißnaht";
		} else if (article.weldlines.length > 1) {
			text = `${article.weldlines.length} Schweißnähte`;
		}
		const numberOfCorners = article.weldlines.reduce((a, b) => {
			return a + b.corners.length;
		}, 0);
		if (numberOfCorners === 1) {
			text += ` | 1 Ecke`;
		} else if (numberOfCorners > 1) {
			text += ` | ${numberOfCorners} Ecken`;
		}
		if (article.weldlines.some((w) => w.clean)) {
			text += ` | verputzt`;
		} else if (article.weldlines.length > 0) {
			text += ` | unverputzt`;
		}
		return text;
	}
}
